// stocai_frontend/src/components/HomePage/components/LearnerContentFrame.jsx

import React from "react";
import { useLocation } from "react-router-dom"; // ✅ ADD THIS

const LearnerContentFrame = ({ layoutPhase, children }) => {
  const location = useLocation(); // ✅ ADD THIS
  const isImmersive = layoutPhase === "immersive";
  const isFull = layoutPhase === "full";
  const isActionPlan = location.pathname.includes("action-plan"); // ✅ ADD THIS

  return (
    <div
      className={`relative mt-[25px] transition-all duration-300 scrollbar-hide ${
        isFull
          ? "left-0 top-0 w-full h-[calc(100vh-15vh)] md:h-[calc(100vh-25px)] rounded-none bg-white flex justify-center"
          : isActionPlan // ✅ ADD THIS CONDITION
          ? "left-[58px] w-[1324px] h-[calc(100vh-15vh)] md:h-[calc(100vh-10vh)]" // ✅ WIDER FOR ACTION PLAN
          : isImmersive
          ? "left-[141px] w-[1267px] h-[calc(100vh-15vh)] md:h-[calc(100vh-10vh)]"
          : "left-[141px] w-[891px] h-[calc(100vh-15vh)] md:h-[calc(100vh-10vh)]"
      } bg-white rounded-2xl shadow-md overflow-y-auto z-0`}
    >
      {children}
    </div>
  );
};

export default LearnerContentFrame;


// import React from "react";

// const LearnerContentFrame = ({ layoutPhase, children }) => {
//   const isImmersive = layoutPhase === "immersive";
//   const isFull = layoutPhase === "full";

//   return (
//     <div
//       className={`relative mt-[25px] transition-all duration-300 scrollbar-hide ${
//         isFull
//           ? "left-0 top-0 w-full h-[calc(100vh-15vh)] md:h-[calc(100vh-25px)] rounded-none bg-white flex justify-center"
//           : isImmersive
//           ? "left-[141px] w-[1267px] h-[calc(100vh-15vh)] md:h-[calc(100vh-10vh)]"
//           : "left-[141px] w-[891px] h-[calc(100vh-15vh)] md:h-[calc(100vh-10vh)]"
//       } bg-white rounded-2xl shadow-md overflow-y-auto z-0`}
//     >
//       {children}
//     </div>
//   );
// };

// export default LearnerContentFrame;
